import axios from "axios";
/*
import createAuthRefreshInterceptor from 'axios-auth-refresh';
  TODO: https://www.npmjs.com/package/axios-auth-refresh
*/

function getAccessToken() {
  return localStorage.getItem("token@mf");
}

const api = axios.create({
  //baseURL: "https://midia-festival-api.herokuapp.com",
  //baseURL: "http://localhost:8080",
  baseURL: "https://prc.midiafestival.com.br",
});

api.interceptors.request.use((request) => {
  const token = getAccessToken();
  if (token) {
    request.headers["Authorization"] = `Bearer ${token}`;
  }
  return request;
});

export function isAuthError(error) {
  const status = error && error.response && error.response.status;
  return status === 401 || status === 403;
}

export function getRequestErrorMessage(error, defaultMessage) {
  if (isAuthError(error)) {
    return "Sua sessão expirou. Por favor, faça login novamente e tente outra vez.";
  }
  const status = error && error.response && error.response.status;
  return status ? `${defaultMessage} (${status})` : defaultMessage;
}

export default api;
